import type { ReactNode } from 'react';

type DescriptionProps = {
    subline?: string;
    noMaxWidth?: boolean;
    children?: ReactNode;
    className?: string;
};

export const Description = (props: DescriptionProps) => {
    const { subline, noMaxWidth, children, className = 'margin-bottom-20' } = props;

    return (
        <div className={className}>
            {subline && <div className='description-subline'>{subline}</div>}
            {children && <div className={`${noMaxWidth ? '' : 'max-width-1000'}`}>{children}</div>}
        </div>
    );
};
